<span class="label">{{ 'regulatory-bar.ageinformation' | jurisdiction | translate }}</span>

<obg-icon-list *ngIf="regulationIcons$ | async as regulationIcons" [icons]="regulationIcons"> </obg-icon-list>

<div class="toggle" (click)="onToggleBar()">
	<span class="ico-chevron-up up"></span>
	<span class="ico-chevron-down down"></span>
</div>
